
<template>
  <div class="report-slider">
    <div v-if="slides && slides.length > 0">
      <div class="requirements-nav">
        <nav>
          <ul>
            <li
              v-for="navItem in slideNav"
              :key="navItem.id"
              class="country__icon"
            >
              <img
                :key="navItem.id"
                class="requirements-nav-checkbox"
                :src="`${formatFlagString(navItem.iso)}`"
                :alt="navItem.name"
              />
            </li>
          </ul>
        </nav>
      </div>
      <div v-if="showSlides && slides && slides.length > 0" class="">
        <swiper ref="reportSlider" :options="optionsPaginationTop" class="">
          <swiper-slide v-for="(article, index) in slides" :key="index">
            <!-- <div class="requirements-wrapper"> -->
            <div class="requirements-row">
              <div class="country-title--wrapper">
                <img
                  :key="article.id"
                  class="requirements-row-flag"
                  :src="`${formatFlagString(article.iso)}`"
                  :alt="article.name"
                />
                <span class="country-title"
                  ><strong>{{ article.name }}</strong></span
                >
              </div>

              <div>
                <!-- eslint-disable vue/no-v-html -->
                <div
                  v-for="(paragraph, idx) in article.paragraphs"
                  :key="idx"
                  v-html="paragraph"
                />
                <!-- eslint-enable vue/no-v-html -->
              </div>
            </div>
            <!-- </div> -->
          </swiper-slide>
        </swiper>
        <DirectionButton
          :props-handle-click="prev"
          class="report-slider__pagination--prev report-slider__pagination-top--prev swiper-button-prev"
          :direction="'prev'"
          :icon="'arrow-left--white'"
        />
        <DirectionButton
          :props-handle-click="next"
          class="report-slider__pagination--next report-slider__pagination-top--next swiper-button-next"
          :direction="'next'"
          :icon="'arrow-right--white'"
        />
      </div>
    </div>
  </div>
</template>

  <script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "ReportSlider",
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    DirectionButton: () => import("@/components/elements/DirectionButton"),
    Swiper,
    SwiperSlide,
  },
  props: {
    slides: {
      type: Array,
      default: null,
    },
    slideNav: {
      type: Array,
      default: null,
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSlides: true,
      optionsPaginationTop: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 45,
        breakpoints: {
          767: {
            slidesPerView: 2,
          },
        },
        navigation: {
          nextEl: ".report-slider__pagination-top--next",
          prevEl: ".report-slider__pagination-top--prev",
        },
      },
    };
  },

  methods: {
    formatFlagString(str) {
      if (str) {
        const iso = str.toLowerCase();
        return `${this.$config.baseURL}/sites/default/files/flag/${iso}.svg`;
      } else {
        return `${this.$config.baseURL}/sites/default/files/flag/vixiocircleflag.svg`;
      }
    },
    hasBeenSelected(itemName) {
      const found = this.jurisdictionNavItems.find(
        (obj) => obj.name === itemName
      );

      if (found.checked) {
        return true;
      } else {
        return false;
      }
    },
    goToPrev() {
      this.$refs.productsSlider.prev();
    },
    goToNext() {
      this.$refs.productsSlider.next();
    },
    next() {
      const slider = "reportSlider";
      this.$refs[slider].$swiper.slideNext();
    },
    prev() {
      const slider = "reportSlider";
      this.$refs[slider].$swiper.slidePrev();
    },
  },
};
</script>

  <style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.report-slider {
  overflow: hidden;
  margin: 1rem 0 0;

  .report-slider__pagination--prev,
  .report-slider__pagination--next {
    position: absolute;
    top: 0;
  }

  .report-slider__pagination--next {
    background: $accentBlue;

    @include below($lg) {
      top: auto;
      bottom: 0;

      &::before {
        display: none;
      }
    }
  }

  .report-slider__pagination--prev {
    left: auto;
    background: $accentBlue;

    @include below($lg) {
      top: auto;
      bottom: 0;

      &::before {
        display: none;
      }
    }
  }
}

// copied from reportcountryscrollable
.country__icon {
  height: 5rem;
  width: 5rem;
  display: inline-block;
  padding-right: 1rem;

  img {
    width: 100%;
  }
}

.country-title {
  text-align: center;
  align-items: center;
  justify-content: center;
  top: -10px;
  &--wrapper {
    display: flex;
  }
}

.requirements-row-flag {
  height: 2.55rem;
  width: 2.5rem;
  display: inline-block;
  padding-right: 1rem;

  img {
    width: 100%;
  }
}

.horizscroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  white-space: nowrap;
}

.inner {
  flex-shrink: 0;
  height: 100%;
  padding: 1rem;
  box-sizing: border-box;
  overflow: hidden;
  word-wrap: break-word;
  flex-direction: column;

  &__content {
    flex: 1;
    padding: 16px;
    width: 470px;

    &p {
      word-wrap: break-word;
    }
  }

  table {
    width: 200px !important;
  }
}

.requirements-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 10px;
}

.requirements-column {
  padding: 10px;
}

.inner-column {
  height: 100px;
}

.requirements-nav nav {
  text-align: center;
}
</style>
